import { Link } from 'react-router-dom';

import {
  ChevronsUpDown,
} from "lucide-react"

import {
  Avatar,
  AvatarFallback,
  AvatarImage,
} from "@/components/ui/avatar"
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu"
import {
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  useSidebar,
} from "@/components/ui/sidebar"
import React from 'react';

type MenuItem = {
  icon: React.ReactNode | (() => React.ReactNode);
  text: string | React.ReactNode;
  to: string;
  isNew?: boolean;
  hideOnLands?: boolean;
  hideOnGarageBuilding?: boolean;
  hideInSharedProperty?: boolean;
  hideInPrivateProperty?: boolean;
  hideInPersonalArea?: boolean;
  notificationLabel?: boolean;
  notificationsBadge?: boolean;
  isExternalLink?: boolean;
  openInNewTab?: boolean;
  className?: string;
};

export function NavUser({user, profileMenuSections}: {
  user: {
    name: string
    email: string
    avatar: string
    avatarNameLetters: string
  },
  profileMenuSections: {
    id: number;
    title?: string;
    mobileOnly?: boolean;
    experimental?: boolean;
    supportSection?: boolean;
    items: MenuItem[];
  }
}) {
  const { isMobile } = useSidebar()
  return (
    <SidebarMenu>
      <SidebarMenuItem>
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <SidebarMenuButton
              size="lg"
              className="data-[state=open]:bg-sidebar-accent data-[state=open]:text-sidebar-accent-foreground"
            >
              <Avatar className="h-8 w-8 rounded-lg text-primary-foreground">
                <AvatarImage src={user.avatar} alt={user.name} />
                <AvatarFallback className="rounded-lg bg-primary">{user.avatarNameLetters}</AvatarFallback>
              </Avatar>
              <div className="grid flex-1 text-left text-sm leading-tight">
                <span className="truncate font-semibold">{user.name}</span>
                <span className="truncate text-xs">{user.email}</span>
              </div>
              <ChevronsUpDown className="ml-auto size-4" />
            </SidebarMenuButton>
          </DropdownMenuTrigger>
          <DropdownMenuContent
            className="w-[--radix-dropdown-menu-trigger-width] min-w-56 rounded-lg"
            side={isMobile ? "bottom" : "right"}
            align="end"
            sideOffset={4}
          >
            <DropdownMenuLabel className="p-0 font-normal">
              <div className="flex items-center gap-2 px-1 py-1.5 text-left text-sm">
                <Avatar className="h-8 w-8 rounded-lg text-primary-foreground">
                  <AvatarImage src={user.avatar} alt={user.name} />
                  <AvatarFallback className="rounded-lg bg-primary">{user.avatarNameLetters}</AvatarFallback>
                </Avatar>
                <div className="grid flex-1 text-left text-sm leading-tight">
                  <span className="truncate font-semibold">{user.name}</span>
                  <span className="truncate text-xs">{user.email}</span>
                </div>
              </div>
            </DropdownMenuLabel>
            <DropdownMenuSeparator />
            {profileMenuSections.map(({ items }, index) => (
              <React.Fragment key={index}>
                <DropdownMenuGroup>
                {items.map(
                  ({
                     text,
                     onClick,
                     className,
                     notificationsBadge,
                     hideInSharedProperty,
                     hideInPersonalArea,
                     icon: Icon,
                     to,
                     isExternalLink,
                   }, index) => (
                    <DropdownMenuItem key={index} className="p-0" onClick={(event) => onClick && onClick(event)}>
                      {isExternalLink ? (
                        <a className="flex p-2 gap-1 w-full items-center" href={to} target="_blank" rel="noopener noreferrer">{Icon && <Icon/>}{text}</a>
                      ) : (
                        <Link className="flex p-2 gap-1 w-full items-center" to={to}>
                          {Icon && <Icon/>}{text}
                        </Link>
                      )}
                    </DropdownMenuItem>
                    ))}
                </DropdownMenuGroup>
                <DropdownMenuSeparator />
              </React.Fragment>
              ))}
          </DropdownMenuContent>
        </DropdownMenu>
      </SidebarMenuItem>
    </SidebarMenu>
  )
}
